import { Component, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { MenuAction } from 'src/app/models/common/common.model';

@Component({
  selector: 'app-delivery-note-upload-button',
  templateUrl: './delivery-note-upload-button.component.html',
  styleUrls: ['./delivery-note-upload-button.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-8px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-8px)' })),
      ]),
    ]),
  ],
})
export class DeliveryNoteUploadButtonComponent {
  @Input() isLoading: boolean = false;
  @Input() hasFile: boolean = false;
  @Input() fileName: string = '';
  @Input() fileDate?: string;
  @Input() showLabel: boolean = true;
  @Input() menuActions: MenuAction[] = [];
  @Input() fullWidth: boolean = false;

  @Output() upload = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() toggleMenu = new EventEmitter<void>();

  showMenu: boolean = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showMenu = false;
    }
  }

  onUpload(): void {
    this.upload.emit();
  }

  onMenuAction(action: MenuAction): void {
    action.action();
    this.showMenu = false;
  }

  onDelete(): void {
    this.delete.emit();
    this.showMenu = false;
  }

  onToggleMenu(): void {
    this.showMenu = !this.showMenu;
    this.toggleMenu.emit();
  }
}
